import { appApi } from '@web/app/store/api'
import type { AuthType, LoginType } from '@web/types'
import { IUser } from '../../usuarios/types'

export const authApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    token: builder.mutation<AuthType, LoginType>({
      query: (body) => ({
        url: `/api/v1/auth/login`,
        method: 'POST',
        body,
      }),
      extraOptions: {
        unauthenticated: true,
      },
    }),
    getUserProfile: builder.query<{ data: IUser }, void>({
      query: () => ({
        url: '/api/v1/users/profile',
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: 'throw',
})
